"use client";

import { useEffect } from "react";
import { useRequestEntryLayoutChrome } from "../RequestEntryLayoutChromeContext";

/**
 * 整備（RequestType=seibi）の request-entry 各ステップから呼ばれる。
 * 整備見積でも当アプリの通常レイアウト（ヘッダー／フッター）を表示する。
 *
 * @param {object | null | undefined} requestRow - init 後の DMD_Request 行（未取得時は null）
 */
export function useSyncRequestEntrySeibiChrome(requestRow) {
  const { setSuppressChrome } = useRequestEntryLayoutChrome();

  useEffect(() => {
    setSuppressChrome(false);
  }, [requestRow, setSuppressChrome]);
}
